module.exports = __webpack_public_path__ + "img/album17_16.f99092f1.jpg";